const einProgram = {
  einProgram: {
    pageHeader: 'Sieć potencjalnych klientów i instalatorów Enphase',
    title: 'Członkostwo w EIN zostało przyznane',
    overview: 'Przegląd',
    noCompany: 'Nie znaleziono firmy',
    goToDashboard: 'Przejdź do pulpitu nawigacyjnego',
    messageFromCeo: 'Przeczytaj wiadomość od naszego dyrektora zarządzającego',
    companyProfileLink: 'Zaktualizuj profil firmy',
    serviceAreasLink: 'Wybierz swoje obszary usług',
    leadsPreferencesLink: 'Ustaw swoje preferencje dotyczące potencjalnych klientów',
    reviewInstallerLink: 'Przejrzyj Zasady i postanowienia dotyczące instalatorów',
    open: 'otwórz',
    video: 'film',
    selected: 'wybrano',
    learnMore: 'Więcej informacji',
    completed: 'Ukończono',
    pending: 'Oczekujące',
    optInDisabledHeader: 'Program EIN (wkrótce)',
    optInDisabledDescription:
      'Sieć instalatorów Enphase (EIN) to świetny sposób, aby właściciele domów mogli Cię znaleźć! Właściciele domów polegają na sieci EIN, aby zidentyfikować instalatorów, którzy zapewniają najwyższe standardy obsługi klienta i jakości systemu przy użyciu produktów Enphase. Jako członek sieci EIN masz dostęp do wielu korzyści, które pomogą Ci sprzedawać, instalować i zarabiać więcej.',
    einTier: 'Twój poziom w sieci Enphase Installer Network (EIN)',
    none: 'Brak',
    viewBenefits: 'Aby wyświetlić korzyści wynikające z sieci EIN, kliknij',
    here: 'tutaj',
    anyQuestions: 'Jeśli masz pytania dotyczące członkostwa w sieci EIN, skontaktuj się ze swoim',
    enphaseAccountRepresentative: 'przedstawicielem Enphase.',
    learnReceivingLeads:
      'Dowiedz się, jak będziesz pozyskiwać potencjalnych klientów za pośrednictwem platformy cyfrowej Enphase,',
    benefitsOfEIN: 'Wyświetl korzyści wynikające z sieci EIN',
    contactEnphaseRepresentative:
      'Skontaktuj się ze swoim przedstawicielem Enphase, aby dowiedzieć się więcej o sieci EIN i programie Enphase dot. potencjalnych klientów.',
    congratulations: 'Gratulujemy!',
    whichInstaller: 'Instalator – poziom %{tierName},',
    invitationText1: 'Zaproszono Cię do sieci Enphase Installer Network (EIN) jako',
    invitationText2:
      'Enphase Installer Network (EIN) to nasza sieć zaufanych instalatorów, którzy zapewniają wyjątkowy poziom usług właścicielom domów przy użyciu produktów Enphase. Sieć EIN ma na celu wzmocnienie naszych relacji z Tobą i przyspieszenie Twojego rozwoju. Jako członek sieci EIN masz dostęp do wielu korzyści, które pomogą Ci sprzedawać, instalować i zarabiać więcej. Zapoznaj się ze wszystkimi korzyściami,',
    acceptInvitation: 'Aby przyjąć zaproszenie',
    acceptTerms: 'Akceptuję Warunki i postanowienia',
    cellmodemCheck: 'Akceptuję',
    cellmodemTeamcondition: ' Warunki i postanowienia ',
    cellmodemLinkTitle: 'z Rozszerzenie Danych Mobilnego Połączenia',
    notEstablished: 'Nie ustalono.',
    contactEin: 'Skontaktuj się ze swoim przedstawicielem Enphase, aby dowiedzieć się więcej o sieci EIN.',
    getFreeLeads: 'Aby pozyskać bezpłatnie potencjalnych klientów, wykonaj poniższe kroki'
  }
};

export default einProgram;
